<template>
    <div class="apprentice-simple-card magazine-templates">
        <div
            class="not-found with-header empty-template-list"
            v-if="templates.length === 0">
            <div class="icon">
                <i class="fas fa-exclamation-circle"></i>
            </div>
            <div class="alert-notice">{{ $t('magazine.no_templates_found') }}</div>
        </div>

        <div
            class="row"
            v-else>
            <div
                class="col-12 col-md-6 magazine-template"
                v-for="template in templates">
                <div class="magazine">
                    <div
                        class="magazine-template-preview"
                        :class="template.thumb === null && 'no-thumbnail'">
                        <img
                            v-if="template.thumb !== null"
                            :src="template.thumb" />
                    </div>
                    <div class="component-title">
                        <h5 class="title">{{ template.title }}</h5>
                        <b-button
                            class="btn-remove-fad btn-remove-template"
                            v-b-tooltip.hover
                            variant="danger-icon"
                            :title="$t('common.delete')"
                            @click="delTemplate(template.id)">
                        </b-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'design-2021-magazine-templatearchive-component.vue',
    props: ['templatesIn', 'magazineIn'],
    data() {
        return {
            templates: this.templatesIn,
            magazine: this.magazineIn,
        };
    },
    methods: {
        delTemplate(id) {
            this.alert
                .confirm(this.$t('common.delete'), this.$t('magazine.are_you_sure_you_want_to_delete_this_template'))
                .then((confirm) => {
                    if (confirm) {
                        this.alert.saving();

                        this.axios.delete(this.routes.magazineTemplateDelete(this.magazine.id, id)).then(
                            (response) => {
                                this.alert.success();
                                for (let template of this.templates) {
                                    if (template.id == id) {
                                        this.templates.splice(this.templates.indexOf(template), 1);
                                    }
                                }
                            },
                            (error) => {
                                this.alert.ajaxError(error);
                            },
                        );
                    }
                });
        },
    },
};
</script>

<style scoped lang="scss">
.magazine {
    display: flex;
    flex-direction: row;
    background-color: $white;
    border-radius: $border-radius-content;
    padding: map-get($grid-gutter-spacing, 'twenty-one') 0;

    .magazine-template-preview {
        width: 40%;
        margin-right: $grid-gutter-width;

        img {
            max-width: 100%;
            width: 100%;
            object-fit: cover;
            object-position: center;
            border-radius: $border-radius-content;
            border: 1px solid $border-color;
        }

        &.no-thumbnail {
            background-color: $inverse-info;
            border-radius: $border-radius-content;

            &:before {
                font-size: 6rem;
                color: $white;
                opacity: 0.3;
                margin-right: 0;
            }

            &:after {
                content: '';
                padding-bottom: 139.5%;
            }
        }
    }

    .component-title {
        display: flex;
        flex: 1 0 60%;
        flex-direction: row;
        justify-content: flex-start;
        align-items: baseline;
        margin-bottom: 0;

        .title {
            align-self: baseline;
            margin-right: map-get($grid-padding-spacing, 'fifteen');
        }

        .btn {
            margin-left: auto;
            margin-right: 0;

            &:before {
                margin-right: 0;
            }
        }
    }
}
</style>
